import { cn } from '@rocco/utils/cn';

interface RevampRichTextProps {
    contentHTML?: string;
    className?: string;
    /**
     * Promote the column's authored `h3` to an `h2`. The page-builder only
     * offers editors an H3 title column, but a module title is the first
     * heading under the article's `h1`, so leaving it at h3 skips a level.
     * Set it on the title columns; body copy keeps its authored levels.
     */
    promoteHeading?: boolean;
}

/** The h2 and h3 rules in this component are identical, so retagging is purely semantic. */
const promoteH3ToH2 = (html: string) => html.replace(/<(\/?)h3\b/gi, '<$1h2');

/**
 * Renders page-builder rich text (already CMS-sanitised, same source as the
 * legacy RichTextDisplay) with the revamp's editorial typography.
 */
export const RevampRichText = ({
    contentHTML,
    className,
    promoteHeading = false,
}: RevampRichTextProps) => {
    if (!contentHTML) return null;

    const html = promoteHeading ? promoteH3ToH2(contentHTML) : contentHTML;

    return (
        <div
            className={cn(
                // Body copy is TWK Ghost per the design spec (22px / 160% /
                // -0.04125rem, #000); headings inside rich text stay Neue Haas.
                'font-ghost font-normal text-black [&_a]:underline [&_h2]:m-0 [&_h2]:mb-6 [&_h2]:font-sans [&_h3]:m-0 [&_h3]:mb-6 [&_h3]:font-sans [&_li]:leading-[1.6] [&_p]:m-0 [&_p]:mb-[1.4rem] [&_p:last-child]:mb-0',
                'text-base leading-[1.6] md:text-[1.375rem] md:leading-[1.6] md:tracking-[-0.04125rem] [&_h2]:text-[1.5rem] [&_h2]:leading-[1.1] md:[&_h2]:mb-[2.1875rem] md:[&_h2]:text-[2rem] md:[&_h2]:tracking-[-0.03em] [&_h3]:text-[1.5rem] [&_h3]:leading-[1.1] md:[&_h3]:mb-[2.1875rem] md:[&_h3]:text-[2rem] md:[&_h3]:tracking-[-0.03em]',
                className,
            )}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
};
